// extracted by mini-css-extract-plugin
export default {"parties":"search_filters_parties-module__parties--1Jx9y","text":"search_filters_parties-module__text--1hGom"};